import { Injectable } from '@angular/core';
import { AjaxService } from '../services/ajax.service';
import * as _ from 'underscore';
import { Utility } from '../shared/utility/utility';

@Injectable()
export class PromotionsService {
  promotionsDataResponse = null;
  promotionsDataCallStack=[];

  private promotionsData;
  private idIndexedPromotions;
  constructor(
    private ajaxService:AjaxService,
    private utility:Utility
    
  ) { }

  setPromotionsData(promotionsData){
    this.promotionsData = promotionsData
  }

  async getAffId(){
    let affId;
    let userLoginStatus = localStorage.getItem('loginstatus') 
    if(this.utility.isUserLoggedIn() || userLoginStatus == 'true'){
      let profileBalanceCurrency:any = await this.ajaxService.profileBalanceAPI.toPromise();
      let aff_Profile_id=profileBalanceCurrency?.profile?.affiliateId;
      
      if(aff_Profile_id && parseInt(aff_Profile_id)){
        return { affiliateId:aff_Profile_id}
      }
      return {}
    }else{
      affId = localStorage.getItem('affiliate') ? JSON.parse(localStorage.getItem('affiliate')) : ""
      if(affId?.affiliate){
        return { affiliateId:affId?.affiliate}
      }else if(location.href.includes('affid')){
        let urlParams = new URLSearchParams(window.location.search);
        let aff_id = urlParams.get('affid');
        if(aff_id && parseInt(aff_id)){
          return { affiliateId:aff_id}
        }
      }
      return {}
    }
  }

  setIdIndexedPromotionsData(idIndexedPromotions){
    this.idIndexedPromotions = idIndexedPromotions
  }

 async getPromotionsData(isForce?, affId={}){
    let affid = await this.getAffId();
    if(!affid && !Object.keys(affId).length){
      affId = {}
    }else{
      affId = affid ? affid : affId
    }
    if(isForce) {
      this.promotionsDataResponse = null;
    }
    if (this.promotionsDataResponse && !isForce){
        return this.promotionsDataResponse;
    } else {
      return new Promise((resolve,reject)=>{
        if(this.promotionsDataCallStack.length > 0){
          this.promotionsDataCallStack.push(resolve);
        }
        else{
          this.promotionsDataCallStack.push(resolve);
          Promise.resolve(this.ajaxService.getPromos(affId)).then(promoData => {
            if(promoData){
              this.promotionsDataResponse = promoData;
              this.setPromotionsData(promoData);
              this.setIdIndexedPromotionsData(_.indexBy(promoData,'url'));
              for(let call in this.promotionsDataCallStack){
                this.promotionsDataCallStack[call](this.promotionsDataResponse);
              }
              this.promotionsDataCallStack=[];
            }
          });
        }
      });
    }
  }

  async getIndexedPromotionData(){
    let affid = await this.getAffId();
    if(!affid || !affid?.affiliateId){
      affid = {}
    }else{
      affid = affid ? affid : {}
    }
    if(this.idIndexedPromotions){
      return this.idIndexedPromotions
    }else{
      return Promise.resolve(this.ajaxService.getPromos(affid))
      .then(
        promoData=>{
          this.setPromotionsData(promoData);
          this.setIdIndexedPromotionsData(_.indexBy(promoData,'url'));
          return this.idIndexedPromotions;
        }
      );
    }
  }
}
